export { default as TagLeftIcon } from './TagLeftIcon'
